import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import app from 'reducers/app';
import carts from 'reducers/carts';
import catalog from 'reducers/catalog';
import contract from 'reducers/contract';
import customer from 'reducers/customer';
import dashboard from 'reducers/dashboard';
import flow from 'reducers/flow';
import initialState from 'reducers/initialState';
import recycle from 'reducers/recycle';
import ui from 'reducers/ui';
import user from 'reducers/user';
import whitelabel from 'reducers/whitelabel';

const store = combineReducers({
  app,
  carts,
  catalog,
  contract,
  customer,
  dashboard,
  form,
  flow,
  recycle,
  ui,
  user,
  whitelabel,
});

const root = (state, action) => {
  if (action.type === 'CLEAN_STORE') {
    return store(
      {
        ...initialState,
        whitelabel: state.whitelabel,
        user: state.user,
        carts: state.carts,
        ui: state.ui,
        form: {
          selectStore: state.form.selectStore,
          language: state.form.language,
        },
      },
      action,
    );
  }

  return store(state, action);
};

export default root;
